module.exports = __webpack_public_path__ + "img/GH.f65b9fe8.svg";